import React, {useEffect, useRef, useState} from 'react'
import './style.scss'
import '../../assets/style/main.css'
import CROSS_ICON from "../../assets/images/icons/x.png"
import CHECKMEMBER_ICON from '../../assets/images/icons/checkmember-icon.png'
import NH_CONNECT_ICON from '../../assets/images/icons/nh-connect.png'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';
import $ from 'jquery'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import useLineLogin from '../../_actions/authLine/lineLogin'
import { NhealthAction } from '../../_actions/action.api'
import { JWTAuthen, SignInPhone, getJWT, getJWTbyPatientID, getPatient, patientVerifySignIn } from '../../_actions/sso.authen'
import { getMemberLab } from '../../_actions/lineoa.authen'
import lineConfig from '../../_actions/authLine/lineConfig'
import liff from '@line/liff'


function SignIn_ConnectVerify() {
    let onceMount = useRef(true);
    
    const [isMember, setIsMember] = useState(false);
    const [msgStatus, setMsgStatus] = useState("กำลังตรวจสอบ");    

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false; 
        }
    }, [])

    const pageInit = async() => {
        await useLineLogin(lineConfig.signin_sso_verify)
        await checkCurrentURL();
        isPageLoading(false);

        //! Bypass
        // let member = {Phoneno: '0954803171'}
        let jwt = await JWTAuthen(); // sso
        await userHandler(jwt);
    }

    const userHandler = (jwtData) => {
        return new Promise(async resolve => {
            setMsgStatus("กำลังเชื่อมต่อระบบ");
            // $('.submit').fadeIn();

            let data = await authorizeChannel(jwtData);
            await getPatient(data)
            .then(() => {
                localStorage.removeItem('line_profile');
                liff.init({ liffId: lineConfig.signin_sso_verify }, () => {
                    liff.logout();
                })
                location.href = `${Base_API.pathWeb}/n-health/signin/success`;
            })
        })
    }

    const getPatient = (data) => {
        return new Promise(async resolve => {
            let jwtData = await getJWTbyPatientID(data.data.patientid);
            
            let headers = {
                token: jwtData.token,
                userRef: data.data.patientid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let rawReq = {
                "refEXP": data.refEXP,
                "isType": data.isType,
                "refAction": data.refAction,
                "refType": data.refType,
            }
            let reqData = {
                data: EncryptedOBJ(rawReq)
            }

            console.log('raw get patient req: ', rawReq);

            NhealthAction.GetPatientProfile(reqData, headers)
            .then(res => {
                console.log('get patient: ', res);
                if(res.IsSuccess)
                {
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA, EncryptedOBJ(res))
                    resolve();
                }
            })
        })
    }

    const authorizeChannel = (jwtData) => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            
            if(!!signin_data_enc)
            {
                let signInData = DecryptedOBJ(signin_data_enc);

                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "data":  {
                        "ref_display": lineProfile.display_name,
                        "ref_profile": lineProfile.picture_url,
                        "ref_user": lineProfile.user_id,
                        "ref_token": !!lineProfile.id_token ? lineProfile.id_token : "",
                        "ref_more1":"",
                        "ref_more2":"",
                        "ref_more3":"",
                        "ref_more4":"",
                        "ref_more5": ""
                    }
                }
                let reqData = {
                    "data": EncryptedOBJ(rawReq)
                }
                NhealthAction.AuthorizeChannel(reqData, headers)
                .then(res => {
                    console.log('res authorize channel: ', res)
                    if(res.IsSuccess)
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res))    
                        resolve(res);
                    }
                })
            }
        })
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    const onSubmit = () => {
        location.href = `${Base_API.pathWeb}/n-health/signin/overview`;
    }

    return (
        <div className='sgn_checkmember_con'>
            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />     
                </div> 
            </div>

            <div className="header">
                <div className="left">
                    <img src={CHECKMEMBER_ICON} />
                </div>
                <div className="mid">
                    <div className="loading">
                    </div>
                </div>
                <div className="right">
                    <img src={NH_CONNECT_ICON} />
                </div>
            </div>

            <div className="title-wrap">
                <h2>
                    {msgStatus}
                </h2>
                <p>
                    ระบบกำลังตรวจสอบข้อมูลของท่าน เพื่อเข้าใช้บริการ N Health
                </p>
            </div>

            <div className="submit">
                <button onClick={onSubmit}>
                    ลงทะเบียน
                </button>
            </div>

            <div className="copyright">
                <p>© All Rights Reserved. N Health. Managed <br/> by NiLECON THAILAND.</p>
            </div>
            
            <PageLoader />
        </div>
    )
}

export default SignIn_ConnectVerify